import Expenses from "./expenses/table-container";
import Grants from "./grants/table-container";
import GrantsHeader from "./investments/grant-header-container";
import Investments from "./investments/table-container";
import LoansHeader from "./loans-header";
import Revenues from "./revenues/table-container";

import Operations from "../../scenarii/common/operations";

const amountCellProps = {
    format: "0,0",
    language: "fr-FR",
    type: "numeric",
    mantissa: 0,
};

const aggregateGrants = (awarded, year, ppi, loans, priorities) => {
    var result = 0,
        amount;
    ppi.investment_themes.map((t) => {
        t.projects.map((p) => {
            if (
                p.visible &&
                (priorities.length == 0 || priorities.indexOf(p.priority) !== -1)
            ) {
                p.grants
                    .filter((g) => g.awarded == awarded)
                    .map((g) => {
                        amount = g.years.find((y) => y.year == year.year).amount;
                        if (amount) {
                            result += amount;
                        }
                    });
            }
        });
        if (t.themes.length > 0) {
            t.themes.map((t) => {
                t.projects.map((p) => {
                    if (
                        p.visible &&
                        (priorities.length == 0 || priorities.indexOf(p.priority) !== -1)
                    ) {
                        p.grants
                            .filter((g) => g.awarded == awarded)
                            .map((g) => {
                                amount = g.years.find((y) => y.year == year.year).amount;
                                if (amount) {
                                    result += amount;
                                }
                            });
                    }
                });
            });
        }
    });
    return result;
};

const reduceTotalInvests = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    fctvaOnly = false
) => {
    var result = 0;
    ppi.investment_themes.map((t) => {
        t.projects.map((p) => {
            if (
                p.visible &&
                (priorities.length == 0 || priorities.indexOf(p.priority) !== -1) &&
                (!fctvaOnly || p.fctva)
            ) {
                result += p.years.find((y) => y.year == year.year).amount;
            }
        });
        t.themes.map((st) => {
            st.projects.map((p) => {
                if (
                    p.visible &&
                    (priorities.length == 0 || priorities.indexOf(p.priority) !== -1) &&
                    (!fctvaOnly || p.fctva)
                ) {
                    result += p.years.find((y) => y.year == year.year).amount;
                }
            });
        });
    });
    return result;
};

const reduceFctva = (year, ppi, loans, priorities) => {
    var result = 0;
    var fctvaRetrieve;
    var toRetrieve = ppi.years.filter((y) => {
        fctvaRetrieve = y.fctvaRetrieve;
        if (fctvaRetrieve == null || fctvaRetrieve == undefined) {
            fctvaRetrieve = ppi.fctvaRetrieve;
        }
        return fctvaRetrieve + y.year === year.year;
    });
    var fctva;
    toRetrieve.map((y) => {
        if (y.fctvaRetrieve === 0) {
            fctva = ppi.years.find((py) => py.year === year.year).fctva / 100;
            if (fctva == null || fctva == undefined) {
                fctva = ppi.fctva / 100
            }
            if (fctva === null || fctva === undefined || fctva === 0) {
                fctva = 0.164
            }
            result +=
                reduceTotalInvests(year, ppi, loans, priorities, null, true) * fctva;
        } else {
            fctva = ppi.years.find((py) => py.year === y.year).fctva / 100;

            if (fctva == null || fctva == undefined) {
                fctva = ppi.fctva / 100
            }
            if (fctva === null || fctva === undefined || fctva === 0) {
                fctva = 0.164
            }
            result +=
                reduceTotalInvests(y, ppi, loans, priorities, null, true) * fctva;
        }
    });
    return result;
};

const _calculateCAFBruteProspective = (
    year,
    la,
    operations,
    previous_scenario,
    loans
) => {
    var result =
        _aggregateOperationsTotalProspective(
            year,
            la,
            operations,
            true,
            previous_scenario,
            loans
        ) -
        _aggregateOperationsTotalProspective(
            year,
            la,
            operations,
            false,
            previous_scenario,
            loans
        );
    result -= _aggregateOrderOperationsTotalProspective(
        year,
        la,
        operations,
        true,
        null,
        previous_scenario
    );
    result += _aggregateOrderOperationsTotalProspective(
        year,
        la,
        operations,
        false,
        null,
        previous_scenario
    );
    return result;
};

const _aggregateOperationsTotalProspective = (
    year,
    la,
    operations,
    receipts,
    previous_scenario,
    loans
) => {
    var result = 0;
    var accounts = la.accounts;
    const loan =
        !receipts && loans
            ? loans.find((loan) => loan.year === year)
            : { interests: 0 };
    if (receipts !== undefined && receipts !== null) {
        accounts = accounts.filter(
            (laca) =>
                laca.account.operation &&
                ((receipts && laca.account.receipts) ||
                    (!receipts && laca.account.expense))
        );
    }
    accounts.map((laca) => {
        if ("66111" === laca.account.number) {
            result += loan ? loan.interests : 0;
        } else {
            result += operations.findValue(
                year,
                laca.account.id,
                laca.chapter ? laca.chapter.id : null,
                receipts,
                previous_scenario
            );
        }
    });
    return result;
};

const _aggregateOrderOperationsTotalProspective = (
    year,
    la,
    operations,
    receipts,
    customNumbers,
    previous_scenario
) => {
    var result = 0,
        obs;
    var accounts = _getOrderOperationAccounts(la, receipts, customNumbers);
    accounts.map((laca) => {
        result += operations.findValue(
            year,
            laca.account.id,
            laca.chapter ? laca.chapter.id : null,
            receipts,
            previous_scenario
        );
    });
    return result;
};

const reducePreviousSurplus = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    if (ppi.years.some(o => o.year == year.year - 1)) {
        const ppiLastYear = ppi.years.find(o => o.year == year.year - 1);
        if (ppiLastYear.investResult != null)
            return ppiLastYear.investResult && ppiLastYear.investResult > 0 ? ppiLastYear.investResult : 0;
    }
    if (ppi.years[0].year == year.year) {
        return ppi.years[0].previousSurplus || 0;
    } else {
        var result = 0;
        if (ppi.years.find((y) => y.year == year.year - 1)) {
            result = reduceTotalPpi(
                ppi.years.find((y) => y.year == year.year - 1),
                ppi,
                loans,
                priorities,
                current_year,
                scenario,
                la
            );
        }
        return result > 0 ? result : 0;
    }
};

export const reduceTotalRevenue = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    var result = 0;
    ppi.revenues.map((r) => {
        result += r.years.find((y) => y.year == year.year).value;
    });
    result += year.saleOfHeritage || 0;
    result += year.tpoRevenue || 0;
    result += year.planningFee || 0;

    var selfFinancing = year.selfFinancing;
    if (scenario) {
        selfFinancing = _aggregateCAFBrute(
            "prospective",
            year.year,
            la,
            _getOperations(scenario, ppi, la),
            loans
        );
    }

    const previousSurplus = reducePreviousSurplus(
        year,
        ppi,
        loans,
        priorities,
        current_year,
        scenario,
        la
    );
    const fctva = reduceFctva(year, ppi, loans, priorities);
    const grantsAwarded = aggregateGrants(true, year, ppi, loans, priorities);
    const grantsAsked = aggregateGrants(false, year, ppi, loans, priorities);

    result += selfFinancing || 0;
    result += previousSurplus;
    result += fctva;
    result += grantsAwarded;
    result += grantsAsked;

    let loan = loans.find((l) => l.year == year.year);
    if (loan) result += loan.total;

    return result;
};

const reduceDeficitRecovery = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    if (ppi.years.some(o => o.year == year.year - 1)) {
        const ppiLastYear = ppi.years.find(o => o.year == year.year - 1);
        if (ppiLastYear.investResult != null)
            return ppiLastYear.investResult && ppiLastYear.investResult < 0 ? Math.abs(ppiLastYear.investResult) : 0;
    }
    if (ppi.years[0].year == year.year) {
        return ppi.years[0].deficitRecovery || 0;
    } else {
        var result = 0;
        if (ppi.years.find((y) => y.year == year.year - 1)) {
            result = reduceTotalPpi(
                ppi.years.find((y) => y.year == year.year - 1),
                ppi,
                loans,
                priorities,
                current_year,
                scenario,
                la
            );
        }
        return result < 0 ? result * -1 : 0;
    }
};

export const reduceTotalSpending = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    var result = 0;
    ppi.expenses.map((r) => {
        result += r.years.find((y) => y.year == year.year).value;
    });
    result += reduceTotalInvests(year, ppi, loans, priorities);
    result += reduceDeficitRecovery(
        year,
        ppi,
        loans,
        priorities,
        current_year,
        scenario,
        la
    );
    result += year.tpoSpending || 0;

    let loan = loans.find((l) => l.year == year.year);
    if (loan) result += loan.reimbourse;

    return result;
};

export const reduceTotalPpi = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    return (
        reduceTotalRevenue(year, ppi, loans, priorities, current_year, scenario, la) - reduceTotalSpending(year, ppi, loans, priorities, current_year, scenario, la)
    );
};

const _aggregateRealOperations = (type, year, la, operations, receipts) => {
    var orderOperationsTotal = _aggregateOrderOperationsTotal(
        type,
        year,
        la,
        operations,
        receipts,
        receipts ? ["042", "043"] : ["042", "043", "023"]
    );
    var operationsTotal = _aggregateOperationsTotal(
        type,
        year,
        la,
        operations,
        receipts
    );
    return operationsTotal - orderOperationsTotal;
};

export const _aggregateCAFBrute = (type, year, la, operations, loans) => {
    if (year < operations.scenario.year) type = "retrospective";

    var result = _aggregateOperationsTotal(type, year, la, operations, true) - _aggregateOperationsTotal(type, year, la, operations, false, loans);
    result -= _aggregateOrderOperationsTotal(type, year, la, operations, true);
    result += _aggregateOrderOperationsTotal(type, year, la, operations, false);
    return result;
};

const orderNumbers = ["68*", "78*", "675*", "676*", "775*", "776*", "777*"];

const _getOrderOperationAccounts = (la, receipts, customNumbers) => {
    let ok;
    let numbers = customNumbers ? customNumbers : orderNumbers;

    return la.accounts.filter((laca) => {
        ok = false;
        if (receipts == undefined || receipts == null || (receipts && laca.account.receipts) || (!receipts && laca.account.expense)) {
            for (const on of numbers) {
                if (ok) continue;

                if (on.indexOf("*") == -1) {
                    ok = laca.chapter && laca.chapter.number == on;
                } else {
                    ok = laca.account.number.startsWith(on.substring(0, on.length - 1));
                }
            }
        }
        return ok;
    });
};

export const _aggregateOrderOperationsTotal = (
    type,
    year,
    la,
    operations,
    receipts,
    customNumbers
) => {
    var result = 0, obs;
    for (const laca of _getOrderOperationAccounts(la, receipts, customNumbers)) {
        if (type == "retrospective") {
            if (obs = la.observations.find((o) => o.year == year && o.account.id == laca.account.id)) {
                result += obs.amount;
            }
        } else {
            result += operations.findValue(year, laca.account.id, laca.chapter ? laca.chapter.id : null, receipts);
        }
    }

    return result;
};

export const _aggregateOperationsTotal = (
    type,
    year,
    la,
    operations,
    receipts,
    loans = null
) => {
    let accounts = la.accounts,
        result = 0,
        obs;

    const loan = !receipts && loans ? loans.find((loan) => loan.year === year) : { interests: 0 };

    if (receipts !== undefined && receipts !== null) {
        accounts = accounts.filter((laca) => laca.account.operation && ((receipts && laca.account.receipts) || (!receipts && laca.account.expense)));
    }

    for (const laca of accounts) {
        if (type == "retrospective") {
            if (obs = la.observations.find((o) => o.year == year && o.account.id == laca.account.id)) {
                result += obs.amount;
            }
        } else {
            if ("66111" === laca.account.number) {
                result += loan ? loan.interests : 0;
            } else {
                result += operations.findValue(year, laca.account.id, laca.chapter ? laca.chapter.id : null, receipts);
            }
        }
    }

    return result;
};

const _reduceSelfFinancing = (
    year,
    ppi,
    loans,
    priorities,
    current_year,
    scenario,
    la
) => {
    if (scenario) {
        return _aggregateCAFBrute("prospective", year.year, la, _getOperations(scenario, ppi, la), loans);
    } else {
        return year.selfFinancing;
    }
};

export const _getOperations = (scenario, ppi, la) => {
    return new Operations(scenario, ppi, la);
};

const FCTVA = {
    key: "FCTVA",
    title: "Taux du FCTVA",
    property: "fctva",
    key: "FCTVA",
    func: (item, ppi, loans, priorities) => (item.fctva || ppi.fctva) / 100,
    cellProps: {
        type: "numeric",
        format: "(0.00 %)",
        culture: "fr-FR",
        mantissa: 2,
    },
};
const FCTVA_RETRIEVE = {
    key: "FCTVA_RETRIEVE",
    title: "Récupération du FCTVA",
    property: "fctvaRetrieve",
    cellProps: {
        editor: "dropdown",
        source: ["N", "N+1", "N+2"],
    },
    mapping: {
        0: "N",
        1: "N+1",
        2: "N+2",
    },
};
const REVENUE = {
    key: "REVENUE",
    title: "Recettes",
    className: "first-header",
    readOnly: true,
};
const PREVIOUS_SURPLUS = {
    key: "PREVIOUS_SURPLUS",
    property: "previousSurplus",
    title: "Reprise de l'excédent N-1",
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = reducePreviousSurplus(
            year,
            ppi,
            loans,
            priorities,
            current_year,
            scenario,
            la
        );
        return result == 0 ? "" : Math.round(result);
    },
    cellProps: amountCellProps
};
const SELF_FINANCING = {
    key: "SELF_FINANCING",
    property: "selfFinancing",
    title: "Autofinancement",
    cellProps: amountCellProps,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        return _aggregateCAFBrute("prospective", year.year, la, _getOperations(scenario, ppi, la), loans);
    },
};
const FCTVA_VALUE = {
    key: "FCTVA_VALUE",
    title: "FCTVA",
    cellProps: amountCellProps,
    readOnly: true,
    defaultValue: "- €",
    func: (year, ppi, loans, priorities) => {
        var result = reduceFctva(year, ppi, loans, priorities);
        return result === 0 ? "" : Math.round(result);
    },
};
const PLANNING_FEE = {
    key: "PLANNING_FEE",
    property: "planningFee",
    title: "Taxe d'aménagement",
    cellProps: amountCellProps,
};
const INFO = {
    key: "ALLOW_UPDATE",
    title: "(Modifiable dans les fiches projets)",
    className: "police",
    readOnly: true,
};

const AWARDED_GRANT = {
    key: "AWARDED_GRANT",
    title: "Subventions octroyées " + INFO.title,
    type: "awarded",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {
        var result = aggregateGrants(true, year, ppi, loans, priorities);
        return result == 0 ? "" : Math.round(result);
    },
    cellComponents: [
        {
            index: 0,
            component: GrantsHeader,
        },
    ],
};
const AWARDED_GRANT_DETAIL = {
    key: "AWARDED_GRANT_DETAIL",
    title: "Awarded detail",
    type: "awarded",
    readOnly: true,
    rowComponent: {
        firstCol: 0,
        component: Grants,
    },
};
const ASKED_GRANT = {
    key: "ASKED_GRANT",
    title: "Subventions demandées " + INFO.title,
    type: "asked",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {
        var result = aggregateGrants(false, year, ppi, loans, priorities);
        return result == 0 ? "" : Math.round(result);
    },
    cellComponents: [
        {
            index: 0,
            component: GrantsHeader,
        },
    ],
};
const ASKED_GRANT_DETAIL = {
    key: "ASKED_GRANT_DETAIL",
    title: "Asked detail",
    type: "asked",
    readOnly: true,
    rowComponent: {
        firstCol: 0,
        component: Grants,
    },
};
const LOANS = {
    key: "LOANS",
    title: "Emprunts",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {        
        let loan = loans.find((l) => l.year == year.year);
        var result = 0;
        if (loan) {
            result = loan.total;
        }
        return result == 0 ? "" : Math.round(result);
    },
    cellComponents: [
        {
            index: 0,
            component: LoansHeader,
        },
    ],
};
const SALE_OF_HERITAGE = {
    key: "SALE_OF_HERITAGE",
    property: "saleOfHeritage",
    title: "Vente de patrimoine",
    cellProps: amountCellProps,
};
const REVENUE_THIRD_PARTIES_OPERATION = {
    key: "REVENUE_THIRD_PARTIES_OPERATION",
    title: "Opération pour compte de tiers",
    cellProps: amountCellProps,
    property: "tpoRevenue",
};
const NEW_REVENUE = {
    key: "NEW_REVENUE",
    title: "Revenues",
    readOnly: true,
    rowComponent: {
        firstCol: 0,
        component: Revenues,
    },
};
const TOTAL_REVENUE = {
    key: "TOTAL_REVENUE",
    title: "Total Recettes",
    cellProps: amountCellProps,
    readOnly: true,
    className: "cat-footer",
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = reduceTotalRevenue(year, ppi, loans, priorities, current_year, scenario, la);
        return result == 0 ? "" : Math.round(result);
    },
};

const SPENDING = {
    key: "SPENDING",
    title: "DEPENSES",
    className: "first-header",
    readOnly: true,
};
const DEFICIT_RECOVERY = {
    key: "DEFICIT_RECOVERY",
    property: "deficitRecovery",
    title: "Reprise du déficit N-1",
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = reduceDeficitRecovery(year, ppi, loans, priorities, current_year, scenario, la);
        return result == 0 ? "" : Math.round(result);
    },
    cellProps: amountCellProps
};
const LOAN_REFUND = {
    key: "LOAN_REFUND",
    title: "Remboursement emprunts",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {
        let loan = loans.find((l) => l.year == year.year);
        var result = 0;
        if (loan) {
            result = loan.reimbourse;
        }
        return result == 0 ? "" : Math.round(result);
    },
};
const INVESTMENTS = {
    key: "INVESTMENTS",
    title: "",
    readOnly: true,
    rowComponent: {
        firstCol: 0,
        component: Investments,
    },
};
const TOTAL_INVESTMENT_FCTVA = {
    key: "TOTAL_INVESTMENT_FCTVA",
    title: "Total des investissements soumis à la FCTVA",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {
        return reduceTotalInvests(year, ppi, loans, priorities, null, true);
    },
};
const TOTAL_INVESTMENT_NO_FCTVA = {
    key: "TOTAL_INVESTMENT_NO_FCTVA",
    title: "Total des investissements non soumis à la FCTVA",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities) => {
        return (
            reduceTotalInvests(year, ppi, loans, priorities, null) -
            reduceTotalInvests(year, ppi, loans, priorities, null, true)
        );
    },
};
const TOTAL_INVESTMENT = {
    key: "TOTAL_INVESTMENT",
    title: "Total des investissements",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        return reduceTotalInvests(year, ppi, loans, priorities, null);
    },
};
const SPENDING_THIRD_PARTIES_OPERATION = {
    key: "SPENDING_THIRD_PARTIES_OPERATION",
    title: "Opération pour compte de tiers",
    cellProps: amountCellProps,
    property: "tpoSpending",
};
const NEW_SPENDING = {
    key: "NEW_SPENDING",
    title: "Dépenses",
    readOnly: true,
    rowComponent: {
        firstCol: 0,
        component: Expenses,
    },
};
const TOTAL_SPENDING = {
    key: "TOTAL_SPENDING",
    title: "Total Dépenses",
    cellProps: amountCellProps,
    className: "cat-footer",
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = reduceTotalSpending(year, ppi, loans, priorities, current_year, scenario, la);
        return result == 0 ? "" : Math.round(result);
    },
    readOnly: true,
};
const ANNUAL_PPI_TOTAL = {
    key: "ANNUAL_PPI_TOTAL",
    title: "Résultat annuel PPI",
    cellProps: amountCellProps,
    className: "ppi-total",
    readOnly: true,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        return reduceTotalPpi(year, ppi, loans, priorities, current_year, scenario, la);
    },
};
const BALANCED_PPI = {
    key: "BALANCED_PPI",
    title: "Équilibre PPI",
    cellProps: amountCellProps,
    className: "ppi-balanced",
    readOnly: true,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        return (
            reduceTotalPpi(year, ppi, loans, priorities, current_year, scenario, la) + _aggregateCAFBrute("prospective", year.year, la, _getOperations(scenario, ppi, la), loans)
        );
    },
};
const RATIOS = {
    key: "RATIOS",
    title: "RATIOS",
    className: "first-header",
    cellProps: amountCellProps,
    readOnly: true,
};
const BRUTE_CAF = {
    key: "BRUTE_CAF",
    title: "CAF Brute ",
    cellProps: amountCellProps,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        return _aggregateCAFBrute("prospective", year.year, la, _getOperations(scenario, ppi, la), loans);
    },
    readOnly: true
};
const CRD = {
    key: "CRD",
    title: "CRD",
    cellProps: amountCellProps,
    readOnly: true,
    func: (year, ppi, loans, priorities, current_year) => {
        let loan = loans.find((l) => l.year == year.year);
        var result = 0;
        if (loan) {
            result = loan.remaining;
        }
        return result == 0 ? "" : Math.round(result);
    },
};
const CAF_DEVELERAGING = {
    key: "CAF_DEVELARGING",
    title: "Désendettement année CAF",
    //cellProps: amountCellProps,
    className: "caf-devel",
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = 0;
        var loan = loans.find((l) => l.year == year.year);
        var CAFBrute = year.selfFinancing;
        if (scenario) {
            CAFBrute = _aggregateCAFBrute(
                "prospective",
                year.year,
                la,
                _getOperations(scenario, ppi, la),
                loans
            );
        }
        if (CAFBrute && loan && loan.remaining) {
            result = loan.remaining / CAFBrute;
        }

        return result;
    },
    readOnly: true,
};
const DEBT_REFUND_PERCENTILE = {
    key: "DEBT_REFUND_PERCENTILE",
    title: "% du remboursement de la dette CAF",
    cellProps: {
        type: "numeric",
        format: "(0.00 %)",
        culture: "fr-FR",
        mantissa: 2,
    },
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var result = 0;
        var loan = loans.find((l) => l.year == year.year);
        var CAFBrute = year.selfFinancing;
        if (scenario) {
            CAFBrute = _aggregateCAFBrute(
                "prospective",
                year.year,
                la,
                _getOperations(scenario, ppi, la),
                loans
            );
        }
        if (CAFBrute && loan && loan.reimbourse) {
            result = loan.reimbourse / CAFBrute;
        }
        return result == 0 ? "" : result;
    },
    readOnly: true,
};
const INVESTMENT_NET_CAF = {
    key: "INVESTMENT_NET_CAF",
    title: "CAF NETTE pour investir",
    cellProps: amountCellProps,
    func: (year, ppi, loans, priorities, current_year, scenario, la) => {
        var loan = loans.find((l) => l.year == year.year);
        var CAFBrute = year.selfFinancing;
        if (scenario) {
            CAFBrute = _aggregateCAFBrute(
                "prospective",
                year.year,
                la,
                _getOperations(scenario, ppi, la),
                loans
            );
        }
        var result = CAFBrute - (loan ? loan.reimbourse : 0);
        return result == 0 ? "" : Math.round(result);
    },
    readOnly: true,
};

const ROWS = [
    FCTVA,
    FCTVA_RETRIEVE,
    REVENUE,
    PREVIOUS_SURPLUS,
    SELF_FINANCING,
    FCTVA_VALUE,
    PLANNING_FEE,
    AWARDED_GRANT,
    AWARDED_GRANT_DETAIL,
    ASKED_GRANT,
    ASKED_GRANT_DETAIL,
    LOANS,
    SALE_OF_HERITAGE,
    REVENUE_THIRD_PARTIES_OPERATION,
    NEW_REVENUE,
    TOTAL_REVENUE,
    SPENDING,
    DEFICIT_RECOVERY,
    LOAN_REFUND,
    INVESTMENTS,
    TOTAL_INVESTMENT_FCTVA,
    TOTAL_INVESTMENT_NO_FCTVA,
    TOTAL_INVESTMENT,
    SPENDING_THIRD_PARTIES_OPERATION,
    NEW_SPENDING,
    TOTAL_SPENDING,
    ANNUAL_PPI_TOTAL,
    // BALANCED_PPI,
    RATIOS,
    BRUTE_CAF,
    CRD,
    CAF_DEVELERAGING,
    DEBT_REFUND_PERCENTILE,
    INVESTMENT_NET_CAF,
];

export default (
    ppi,
    as_responsible,
    current_year,
    shownGrants,
    la,
    scenario
) => {
    var result = {};
    var rows = [];
    var index = 0;
    ROWS.map((row) => {
        if (checkAddRow(ppi, as_responsible, row, shownGrants)) {
            row.index = index;
            rows.push(row);
            index++;
        }
    });

    return {
        FCTVA,
        FCTVA_RETRIEVE,
        REVENUE,
        PREVIOUS_SURPLUS,
        SELF_FINANCING,
        FCTVA_VALUE,
        PLANNING_FEE,
        AWARDED_GRANT,
        AWARDED_GRANT_DETAIL,
        ASKED_GRANT,
        ASKED_GRANT_DETAIL,
        LOANS,
        SALE_OF_HERITAGE,
        REVENUE_THIRD_PARTIES_OPERATION,
        NEW_REVENUE,
        TOTAL_REVENUE,
        SPENDING,
        DEFICIT_RECOVERY,
        LOAN_REFUND,
        INVESTMENTS,
        TOTAL_INVESTMENT_FCTVA,
        TOTAL_INVESTMENT_NO_FCTVA,
        TOTAL_INVESTMENT,
        SPENDING_THIRD_PARTIES_OPERATION,
        NEW_SPENDING,
        TOTAL_SPENDING,
        ANNUAL_PPI_TOTAL,
        // BALANCED_PPI,
        RATIOS,
        BRUTE_CAF,
        CRD,
        CAF_DEVELERAGING,
        DEBT_REFUND_PERCENTILE,
        INVESTMENT_NET_CAF,
        rows: rows,
    };
};

const checkAddRow = (ppi, as_responsible, row, shownGrants) => {
    if (as_responsible) {
        var ok = false;
        switch (row.title) {
            case REVENUE.title:
            case FCTVA_VALUE.title:
            case AWARDED_GRANT.title:
            case ASKED_GRANT.title:
            case TOTAL_REVENUE.title:
            case SPENDING:
            case INVESTMENTS.title:
            case TOTAL_SPENDING.title:
            case ANNUAL_PPI_TOTAL.title:
                // case BALANCED_PPI.title:
                ok = true;
                break;
        }
        return ok;
    } else if (row.title == AWARDED_GRANT_DETAIL.title || row.title == ASKED_GRANT_DETAIL.title) {
        return shownGrants.indexOf(row.type) !== -1;
    } else {
        return (ppi.thirdParties ||
            (row.title !== REVENUE_THIRD_PARTIES_OPERATION.title &&
                row.title !== SPENDING_THIRD_PARTIES_OPERATION.title)
        );
    }
};



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/table-rows.js